const md = `
## STRUCTURED FINANCE HELPS BUILD STRONG COMMUNITIES AND A MORE INCLUSIVE ECONOMY BY FACILITATING ACCESS TO CREDIT, ENABLING BUSINESSES AND HOUSEHOLDS TO FLOURISH


`;

export default md;
